export default "__VITE_ASSET__CxycYbA9__"